import genericStore from "../generic_store";

export default {
    namespaced: genericStore.namespaced,
    state: {
        ...genericStore.state,
        endpoint: "cars",
        object: "car",
        header: [
            { text: "Usuario", value: "user" },
            { text: "Patente", value: "patent" },
            { text: "Auto", value: "car" },
            { text: "FECHA DE INGRESO DEL AUTO", value: "created_at" },
            { text: "Acciones", value: "actions", sortable: false }
        ],
        options: {
            sortBy: ["_id"],
            sortDesc: [false],
        },
    },
    mutations: {
        ...genericStore.mutations
    },
    actions: {
        ...genericStore.actions
    },
    getters: {
        ...genericStore.getters
    }
};
